import React from 'react';

const BrandMark = () => (
  <span className="brand-mark">
    <img
      src="/brand-mark.svg"
      alt="Felicia G. Awuah logo"
      className="brand-mark__icon"
    />
    <span className="brand-mark__text">Felicia G. Awuah</span>
  </span>
);

export default BrandMark;
